import React, { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown, DollarSign, Calendar } from 'lucide-react';

const QuickStats = ({ userId }) => {
  const [stats, setStats] = useState({
    thisMonth: { spent: 0, received: 0, groups: 0 },
    lastMonth: { spent: 0, received: 0, groups: 0 }
  });

  // This would calculate from your existing data
  const calculateTrends = () => {
    const spentChange = stats.thisMonth.spent - stats.lastMonth.spent;
    const receivedChange = stats.thisMonth.received - stats.lastMonth.received;
    
    return { spentChange, receivedChange };
  };

  const { spentChange, receivedChange } = calculateTrends();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <Calendar className="h-5 w-5 mr-2 text-teal-600" />
        Monthly Overview
      </h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600">
            ₹{stats.thisMonth.spent.toFixed(0)}
          </div>
          <div className="text-sm text-gray-600">Spent This Month</div>
          <div className={`text-xs flex items-center justify-center mt-1 ${
            spentChange >= 0 ? 'text-red-500' : 'text-green-500'
          }`}>
            {spentChange >= 0 ? <TrendingUp className="h-3 w-3 mr-1" /> : <TrendingDown className="h-3 w-3 mr-1" />}
            {Math.abs(spentChange).toFixed(0)} vs last month
          </div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">
            ₹{stats.thisMonth.received.toFixed(0)}
          </div>
          <div className="text-sm text-gray-600">Received This Month</div>
          <div className={`text-xs flex items-center justify-center mt-1 ${
            receivedChange >= 0 ? 'text-green-500' : 'text-red-500'
          }`}>
            {receivedChange >= 0 ? <TrendingUp className="h-3 w-3 mr-1" /> : <TrendingDown className="h-3 w-3 mr-1" />}
            {Math.abs(receivedChange).toFixed(0)} vs last month
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickStats;
